
import {Component, Vue} from "vue-property-decorator";
import ContentPageLayout from "@/components/UI/renewal/ContentPageLayout.vue";
import MessageContent from "@/components/message/MessageContent.vue";

@Component({
  components: {
    ContentPageLayout,
    MessageContent,
  },
})
export default class Message extends Vue {
}
